import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import versionFile from '../assets/config/version.json';

@Injectable()
export class CustomAppConfig {
  private configuration: any;
  private RELEASE_VERSION;

  constructor() {}

  public get(key: any): any {
    return this.configuration[key];
  }

  public getVersion(): any {
    return this.RELEASE_VERSION;
  }

  public load(): Promise<unknown> {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', environment.filePath);
      this.RELEASE_VERSION = versionFile.RELEASE_VERSION;
      console.log(this.RELEASE_VERSION);
      xhr.addEventListener('readystatechange', () => {
        if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
          this.configuration = JSON.parse(xhr.responseText);
          resolve(this.configuration);
        } else if (xhr.readyState === XMLHttpRequest.DONE) {
          reject();
        }
      });
      xhr.send(null);
    });
  }
}
